import React, { useMemo } from 'react';
import { Divider, Grid, makeStyles, Modal, Paper } from '@material-ui/core';
import CustomButton from '../../../control/button/Button';

const useStyles = makeStyles((theme) => ({
    modalLabel: {
        fontSize: '20px',
        fontWeight: '700',
    },
    modalValue: {
        fontWeight: '400',
    },
    modalTitle: {
        fontSize: '30px',
        marginBottom: '18px',
    },
    label: {
        fontSize: '30px',
        fontWeight: '400',
        paddingBottom: '4px',
    },
    btnCancel: {
        backgroundColor: '#808080 !important',
        width: '140px',
        height: '40px',
    },
    paper: {
        overflowY: 'auto',
        overflowX: 'hidden',
        backgroundColor: theme.palette.background.paper,
        padding: '30px',
        width: '50%',
        maxHeight: '70%',
        [theme.breakpoints.down('sm')]: {
            width: '90%',
            padding: '24px',
        },
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainBody: {
        '& .MuiGrid-item': {
            padding: 0,
        },
    },
    footer: {
        paddingTop: '18px',
    },
    invalidRowTitle: {
        fontWeight: '700',
        fontSize: '20px',
        marginBottom: '12px',
    },
    divider: {
        margin: '12px 0px',
    },
    firstRowPadding: {
        paddingLeft: '16px',
    },
    invalidRowTable: {
        marginBottom: '24px',
    },
    modalInfoDetail: {
        fontSize: '20px',
        fontWeight: '400',
        color: theme.mainTheme.color1,
    },
}));

const ModalValidateFileError = ({ validateError, onClose }) => {
    const classes = useStyles();

    const internal = useMemo(() => {
        return validateError.sections.internal;
    }, [validateError]);

    const external = useMemo(() => {
        return validateError.sections.external;
    }, [validateError]);

    return (
        <Modal
            open={!!validateError}
            onClose={onClose}
            className={classes.modal}
            disableBackdropClick
        >
            <Paper className={classes.paper}>
                <Grid container justify="center">
                    {internal.isOverLimit || external.isOverLimit ? (
                        <>
                            <Grid item xs={12} className={classes.modalTitle}>
                                พบจำนวนผู้เข้าร่วมเกินโควต้าที่คุณตั้งค่าไว้
                            </Grid>
                            <Grid container>
                                <Grid item xs={4}></Grid>
                                <Grid item xs={4}>
                                    จำนวนที่พบในไฟล์ข้อมูล
                                </Grid>
                                <Grid item xs={4}>
                                    จำนวนที่กำหนด
                                </Grid>
                                <Grid item xs={12}>
                                    <Divider className={classes.divider} />
                                </Grid>
                                {internal.isOverLimit && (
                                    <>
                                        <Grid item xs={4}>
                                            พนักงานและลูกจ้างพนักงาน
                                        </Grid>
                                        <Grid item xs={4}>
                                            {internal.totalRow}
                                        </Grid>
                                        <Grid item xs={4}>
                                            {internal.maxCount}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Divider
                                                className={classes.divider}
                                            />
                                        </Grid>
                                    </>
                                )}
                                {external.isOverLimit && (
                                    <>
                                        <Grid item xs={4}>
                                            บุคคลภายนอก
                                        </Grid>
                                        <Grid item xs={4}>
                                            {external.totalRow}
                                        </Grid>
                                        <Grid item xs={4}>
                                            {external.maxCount}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Divider
                                                className={classes.divider}
                                            />
                                        </Grid>
                                    </>
                                )}
                                <Grid
                                    item
                                    xs={12}
                                    className={classes.modalInfoDetail}
                                >
                                    *ระบบไม่สามารถบันทึกข้อมูลได้กรุณาแก้ไขจำนวนและบันทึกข้อมูลกิจกรรมอีกครั้ง
                                </Grid>
                            </Grid>
                        </>
                    ) : (
                        <>
                            <Grid item xs={12} className={classes.modalTitle}>
                                พบข้อมูลรายชื่อลงทะเบียนล่วงหน้าไม่ถูกต้อง
                            </Grid>
                            {/* internal */}
                            {internal.hasInvalidRows && (
                                <Grid
                                    item
                                    xs={12}
                                    className={classes.invalidRowTable}
                                >
                                    <Grid container>
                                        <Grid
                                            item
                                            xs={12}
                                            className={classes.invalidRowTitle}
                                        >
                                            พนักงานและลูกจ้างพนักงาน พบจำนวน{' '}
                                            {internal.invalidRows.length} รายจาก
                                            (จากทั้งหมด {internal.totalRow}{' '}
                                            รายการ) ตามรายการด้านล่าง
                                        </Grid>
                                        <Grid container spacing={1}>
                                            <Grid
                                                item
                                                xs={2}
                                                className={
                                                    classes.firstRowPadding
                                                }
                                            >
                                                แถวที่
                                            </Grid>
                                            <Grid item xs={4}>
                                                รหัสพนักงาน
                                            </Grid>
                                            <Grid item xs={6}>
                                                สาเหตุ
                                            </Grid>
                                        </Grid>
                                        {internal.invalidRows.map((row) => {
                                            return (
                                                <Grid
                                                    item
                                                    xs={12}
                                                    key={row.rowIndex}
                                                >
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={12}>
                                                            <Divider
                                                                className={
                                                                    classes.divider
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={2}
                                                            className={
                                                                classes.firstRowPadding
                                                            }
                                                        >
                                                            {row.rowIndex}
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={4}
                                                            style={{
                                                                overflow:
                                                                    'hidden',
                                                                whiteSpace:
                                                                    'nowrap',
                                                                textOverflow:
                                                                    'ellipsis',
                                                            }}
                                                        >
                                                            {row.empId || '-'}
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={6}
                                                            style={{
                                                                overflow:
                                                                    'hidden',
                                                                whiteSpace:
                                                                    'nowrap',
                                                                textOverflow:
                                                                    'ellipsis',
                                                            }}
                                                        >
                                                            {row.reason}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </Grid>
                            )}
                            {/* external */}
                            {external.hasInvalidRows && (
                                <Grid
                                    item
                                    xs={12}
                                    className={classes.invalidRowTable}
                                >
                                    <Grid container>
                                        <Grid
                                            item
                                            xs={12}
                                            className={classes.invalidRowTitle}
                                        >
                                            บุคคลภายนอก พบจำนวน{' '}
                                            {external.invalidRows.length} รายจาก
                                            (จากทั้งหมด {external.totalRow}{' '}
                                            รายการ) ตามรายการด้านล่าง
                                        </Grid>
                                        <Grid container spacing={1}>
                                            <Grid
                                                item
                                                xs={2}
                                                className={
                                                    classes.firstRowPadding
                                                }
                                            >
                                                แถวที่
                                            </Grid>
                                            <Grid item xs={4}>
                                                อีเมล
                                            </Grid>
                                            <Grid item xs={6}>
                                                สาเหตุ
                                            </Grid>
                                        </Grid>
                                        {external.invalidRows.map((row) => {
                                            return (
                                                <Grid
                                                    item
                                                    xs={12}
                                                    key={row.rowIndex}
                                                >
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={12}>
                                                            <Divider
                                                                className={
                                                                    classes.divider
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={2}
                                                            className={
                                                                classes.firstRowPadding
                                                            }
                                                        >
                                                            {row.rowIndex}
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={4}
                                                            style={{
                                                                overflow:
                                                                    'hidden',
                                                                whiteSpace:
                                                                    'nowrap',
                                                                textOverflow:
                                                                    'ellipsis',
                                                            }}
                                                        >
                                                            {row.email || '-'}
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={6}
                                                            style={{
                                                                overflow:
                                                                    'hidden',
                                                                whiteSpace:
                                                                    'nowrap',
                                                                textOverflow:
                                                                    'ellipsis',
                                                            }}
                                                        >
                                                            {row.reason}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </Grid>
                            )}
                            <Grid
                                item
                                xs={12}
                                className={classes.modalInfoDetail}
                            >
                                *ระบบไม่สามารถบันทึกข้อมูลได้กรุณาแก้ไขและอัปโหลดรายชื่อลงทะเบียนล่วงหน้าใหม่อีกครั้ง
                            </Grid>
                        </>
                    )}
                    <Grid
                        container
                        spacing={2}
                        justify="center"
                        className={classes.footer}
                    >
                        <Grid item>
                            <CustomButton
                                label="ปิด"
                                onClick={onClose}
                                className={classes.btnCancel}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </Modal>
    );
};

export default ModalValidateFileError;
